import { Subscription } from 'rxjs';
import { Component, OnInit, AfterViewInit, HostListener } from '@angular/core';

import { EventService } from '../core/services/event.service';

import {
  LAYOUT_VERTICAL, LAYOUT_HORIZONTAL, LAYOUT_WIDTH_FLUID,
  LAYOUT_WIDTH_BOXED,  SIDEBAR_THEME_DARK,
} from './layout.model';

@Component({
  selector: 'sn-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})

export class LayoutComponent implements OnInit, AfterViewInit {
  subscription$: Subscription = new Subscription();

  // layout related config
  layoutType: string;
  layoutWidth: string;
  leftSidebarTheme: string;
  leftSidebarWidth: string;

  constructor(private eventService: EventService) { }

  ngOnInit() {
    // default settings
    this.layoutType = LAYOUT_VERTICAL;
    this.layoutWidth = LAYOUT_WIDTH_FLUID;

    this.leftSidebarTheme = SIDEBAR_THEME_DARK;
    this.leftSidebarWidth = 'default';

    // listen to event and change the layout, theme, etc
    this.subscription$.add(this.eventService.subscribe('changeLayout', (layout) => {
      this.layoutType = layout;
    }));

    this.subscription$.add(this.eventService.subscribe('changeLeftSidebarTheme', (theme) => {
      this.leftSidebarTheme = theme;
    }));

    this.subscription$.add(this.eventService.subscribe('changeLeftSidebarType', (type) => {
      this.leftSidebarWidth = type;
    }));

    this.subscription$.add(this.eventService.subscribe('changeLayoutWidth', (width) => {
      this.layoutWidth = width;
    }));
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {

    if (event.target.innerWidth <= 1024){
      this.leftSidebarWidth = 'condensed';
    } else {
      this.leftSidebarWidth = 'default';
    }
  }
  ngAfterViewInit() {
  }

  /**
   * Check if the vertical layout is requested
   */
  isVerticalLayoutRequested() {
    return this.layoutType === LAYOUT_VERTICAL;
  }

  /**
   * Check if the horizontal layout is requested
   */
  isHorizontalLayoutRequested() {
    return this.layoutType === LAYOUT_HORIZONTAL;
  }

  /**
   * Is boxed layout requeted
   */
  isBoxedRequested() {
    return this.layoutWidth === LAYOUT_WIDTH_BOXED;
  }
  ngOnDestroy() {
    this.subscription$.unsubscribe();
  }
}
